import React from "react";
import "./Main.scss";

export function Main(props) {
    return (
        <main>
            {props.children}
        </main>
    )
}
